module.exports = __webpack_public_path__ + "img/face-icon.f4f3dd7a.png";